import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import CommonDialog from './common/CommonDialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { LoginInfo } from '../App';
import { 
    Box, 
    Card, 
    CardContent, 
    Typography, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails,
    Grid,
    Chip,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Alert as MuiAlert,
    Button as MuiButton,
    IconButton,
    Tooltip,
    Paper,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Collapse,
    Stack,
    Fade
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import ReportIcon from '@mui/icons-material/Report';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HistoryIcon from '@mui/icons-material/History';
import GetAppIcon from '@mui/icons-material/GetApp';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon2 from '@mui/icons-material/ExpandMore';

const UserManageInfo = (props) => {
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId+"/manage")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const {t} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const location = useLocation()
    let param = useParams();
    let userIdOrDisplayId = props.userIdOrDisplayId;
    const [userId,setUserId] = useState("")

    // ユーザー情報
    const [userInfo, setUserInfo] = useState(props.userInfo)
    // フォロー
    const [followCount, setFollowCount] = useState(0)
    const [followerCount, setFollowerCount] = useState(0)

    // ポイント
    const [point,setPoint] = useState(0)
    const [totalPointsUsed,setTotalPointsUsed] = useState(0)
    const [postGetPoint,setPostGetPoint] = useState(0)
    const [basePoint,setBasePoint] = useState(0)

    // 投稿数
    const [imageCount,setImageCount] = useState(0)
    // 投稿枚数
    const [imageDetailCount,setImageDetailCount] = useState(0)
    // 合計閲覧数
    const [pvAllCount,setPVAllCount] = useState(0)
    // 過去3ヵ月間の平均PV
    const [pv3MonthCount,setPV3MonthCount] = useState(0)
    // 過去3ヵ月間の平均PV順位
    const [pv3MonthRank,setPV3MonthRank] = useState(0)
    // 合計いいねされた数
    const [favoriteCount,setFavoriteCount] = useState(0)
    // 合計いいねした数
    const [favoritedCount,setFavoritedCount] = useState(0)

    // 画像情報の編集(管理者による)
    const [imageEditAdminCount,setImageEditAdminCount] = useState(0)
    // 画像の削除(管理者による)
    const [imageDeleteAdminCount,setImageDeleteAdminCount] = useState(0)
    // 画像のモザイク再編集(管理者による)
    const [imageMosaicEditAdminCount,setImageMosaicEditAdminCount] = useState(0)
    // 管理者による年齢制限の変更
    const [ageLimitChangeAdminCount,setAgeLimitChangeAdminCount] = useState(0)
    // 管理者による年齢制限の注意喚起
    const [ageLimitAlertCount,setageLimitAlertCount] = useState(0)
    // 管理者による画風の変更
    const [styleOfPaintingChangeAdminCount,setStyleOfPaintingChangeAdminCount] = useState(0)
    // 管理者によるモザイク是正要求
    const [mosaicAlertAdminCount,setMosaicAlertAdminCount] = useState(0)
    // AI生成機能の利用停止措置
    const [aiGenerateSuspendCount,setAIGenerateSuspendCount] = useState(0)
    // 生成機能に対するNGワード入力
    const [generateImageNsfwWordCount,setGenerateImageNsfwWordCount] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止)
    const [statusChangeAdminCount,setStatusChangeAdminCount] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止) 利用規約違反
    const [statusChangeAdminCount1,setStatusChangeAdminCount1] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止) 写実的な児童ポルノコンテンツの投稿
    const [statusChangeAdminCount2,setStatusChangeAdminCount2] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止) 写実的な児童ポルノコンテンツの生成
    const [statusChangeAdminCount3,setStatusChangeAdminCount3] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止) 著作権侵害
    const [statusChangeAdminCount4,setStatusChangeAdminCount4] = useState(0)
    // 管理者によるアカウントステータス変更(一時停止) 不審な操作
    const [statusChangeAdminCount5,setStatusChangeAdminCount5] = useState(0)
    // 通報された回数
    const [reportCountInfo,setReportCountInfo] = useState([])

    const [loading,setLoading] = useState(true)

    // ダイアログ状態管理
    const [detailDialog, setDetailDialog] = useState({
        open: false,
        title: '',
        content: null,
        type: '',
        data: null,
        actionType: ''
    });

    // シンプルな通知ダイアログ
    const [notificationDialog, setNotificationDialog] = useState({
        open: false,
        title: '',
        message: ''
    });

    // ダイアログ内のタブ状態
    const [dialogTab, setDialogTab] = useState(0);

    // 詳細表示の展開状態
    const [expandedDetails, setExpandedDetails] = useState({});

    // 詳細ダイアログを開く関数
    const openDetailDialog = (title, content, type = 'info', data = null, actionType = '') => {
        setDetailDialog({
            open: true,
            title,
            content,
            type,
            data,
            actionType
        });
        setDialogTab(0); // タブをリセット
    };

    // 詳細ダイアログを閉じる関数
    const closeDetailDialog = () => {
        setDetailDialog({
            open: false,
            title: '',
            content: null,
            type: '',
            data: null,
            actionType: ''
        });
        setDialogTab(0);
        setExpandedDetails({});
    };

    // 通知ダイアログ表示
    const showNotification = (title, message) => {
        setNotificationDialog({
            open: true,
            title,
            message
        });
    };

    // 通知ダイアログを閉じる
    const closeNotificationDialog = () => {
        setNotificationDialog({
            open: false,
            title: '',
            message: ''
        });
    };

    // タブ変更ハンドラー
    const handleTabChange = (event, newValue) => {
        setDialogTab(newValue);
    };

    // 詳細展開ハンドラー
    const handleExpandDetails = (key) => {
        setExpandedDetails(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // 管理者行動の詳細説明を取得
    const getActionDescription = (actionType, count) => {
        const descriptions = {
            imageEdit: '投稿された画像の情報（タイトル、説明文、タグなど）を管理者が修正した回数です。',
            imageDelete: '規約違反やその他の理由により、管理者が画像を削除した回数です。',
            mosaicEdit: '年齢制限のある画像のモザイク処理を管理者が再編集した回数です。',
            ageLimit: '投稿された画像の年齢制限設定を管理者が変更した回数です。警告レベル：10回以上で要注意',
            ageLimitAlert: '年齢制限に関する注意喚起を管理者が行った回数です。警告レベル：5回以上で要注意',
            styleChange: '画像の画風分類を管理者が変更した回数です。',
            mosaicAlert: 'モザイク処理に関する是正通知を管理者が送信した回数です。',
            aiSuspend: 'AI生成機能の利用を管理者が制限した回数です。重要度：高',
            nsfwWord: 'AI生成時にNGワードを入力した回数です。重要度：高'
        };
        return descriptions[actionType] || '詳細情報は利用できません。';
    };

    // 統計データの生成
    const generateStatisticsData = (actionType, count) => {
        const now = new Date();
        const pastDates = Array.from({ length: 6 }, (_, i) => {
            const date = new Date(now);
            date.setMonth(date.getMonth() - i);
            return date;
        }).reverse();

        // ダミーデータ生成（実際の実装では API から取得）
        const monthlyData = pastDates.map(date => ({
            month: date.toLocaleDateString('ja-JP', { year: 'numeric', month: 'short' }),
            count: Math.floor(Math.random() * Math.max(1, count / 3))
        }));

        return monthlyData;
    };

    // 詳細な履歴データの生成
    const generateHistoryData = (actionType, count) => {
        const actions = [];
        const actionNames = {
            imageEdit: '画像情報修正',
            imageDelete: '画像削除',
            mosaicEdit: 'モザイク修正',
            ageLimit: '年齢制限変更',
            ageLimitAlert: '年齢制限注意',
            styleChange: '画風変更',
            mosaicAlert: 'モザイク是正',
            aiSuspend: 'AI機能停止',
            nsfwWord: 'NGワード検出'
        };

        // ダミーデータ生成（実際の実装では API から取得）
        for (let i = 0; i < Math.min(count, 10); i++) {
            const date = new Date();
            date.setDate(date.getDate() - Math.floor(Math.random() * 90));
            
            actions.push({
                id: i + 1,
                action: actionNames[actionType] || '不明な操作',
                date: date.toLocaleString('ja-JP'),
                reason: getActionReasons(actionType)[Math.floor(Math.random() * getActionReasons(actionType).length)],
                severity: getSeverityFromType(actionType),
                details: `操作ID: ${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`
            });
        }

        return actions.sort((a, b) => new Date(b.date) - new Date(a.date));
    };

    // 操作理由の取得
    const getActionReasons = (actionType) => {
        const reasons = {
            imageEdit: ['タイトルの修正', 'タグの追加', '説明文の修正', 'カテゴリ変更'],
            imageDelete: ['規約違反', '著作権侵害', 'ユーザー削除要求', '不適切なコンテンツ'],
            mosaicEdit: ['モザイク不十分', 'モザイク過剰', '年齢制限に伴う調整'],
            ageLimit: ['年齢制限追加', '年齢制限解除', '制限レベル変更'],
            ageLimitAlert: ['初回警告', '再警告', '最終警告'],
            styleChange: ['画風誤分類', 'ユーザー申請', '自動分類エラー'],
            mosaicAlert: ['モザイク不備指摘', '再モザイク要求'],
            aiSuspend: ['規約違反', '不正利用検出', '大量生成制限'],
            nsfwWord: ['NGワード検出', 'フィルター回避試行']
        };
        return reasons[actionType] || ['詳細不明'];
    };

    // 重要度の取得
    const getSeverityFromType = (actionType) => {
        const severityMap = {
            imageEdit: 'low',
            imageDelete: 'medium',
            mosaicEdit: 'medium',
            ageLimit: 'high',
            ageLimitAlert: 'high',
            styleChange: 'low',
            mosaicAlert: 'medium',
            aiSuspend: 'critical',
            nsfwWord: 'critical'
        };
        return severityMap[actionType] || 'low';
    };

    // 停止措置の詳細情報を生成
    const getSuspensionDetails = () => {
        const suspensions = [
            { type: '利用規約違反', count: statusChangeAdminCount1, severity: 'error' },
            { type: '児童ポルノコンテンツの投稿', count: statusChangeAdminCount2, severity: 'error' },
            { type: '児童ポルノコンテンツの生成', count: statusChangeAdminCount3, severity: 'error' },
            { type: '著作権侵害', count: statusChangeAdminCount4, severity: 'error' },
            { type: '不審な操作', count: statusChangeAdminCount5, severity: 'error' }
        ];

        return (
            <Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    アカウント停止措置の詳細情報
                </Typography>
                {suspensions.map((item, index) => (
                    <Box key={index} sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        py: 1,
                        borderBottom: index < suspensions.length - 1 ? '1px solid #eee' : 'none'
                    }}>
                        <Typography variant="body2">{item.type}</Typography>
                        <Chip 
                            size="small" 
                            label={`${item.count}回`} 
                            color={item.count > 0 ? 'error' : 'default'}
                        />
                    </Box>
                ))}
                <Typography variant="caption" sx={{ mt: 2, display: 'block', color: 'text.secondary' }}>
                    これらの措置は利用規約違反に基づいて実施されています。
                </Typography>
            </Box>
        );
    };

    // 拡張されたダイアログコンテンツの生成
    const generateEnhancedDialogContent = (actionType, count) => {
        // 停止措置専用のコンテンツ
        if (actionType === 'suspension') {
            return generateSuspensionDialogContent(count);
        }

        const statisticsData = generateStatisticsData(actionType, count);
        const historyData = generateHistoryData(actionType, count);

        return (
            <Box sx={{ width: '100%', minHeight: '400px', overflow: 'hidden' }}>
                <Tabs 
                    value={dialogTab} 
                    onChange={handleTabChange} 
                    variant="scrollable" 
                    scrollButtons="auto"
                    sx={{ 
                        borderBottom: 1, 
                        borderColor: 'divider', 
                        mb: 2,
                        '& .MuiTab-root': {
                            minWidth: { xs: 'auto', sm: 160 }
                        }
                    }}
                >
                    <Tab label="概要" icon={<InfoIcon />} />
                    <Tab label="統計" icon={<AssessmentIcon />} />
                    <Tab label="履歴" icon={<HistoryIcon />} />
                    <Tab label="詳細分析" icon={<TrendingUpIcon />} />
                </Tabs>

                {/* 概要タブ */}
                {dialogTab === 0 && (
                    <Fade in={dialogTab === 0}>
                        <Box>
                            <Paper sx={{ p: 3, mb: 2, backgroundColor: '#f8f9fa' }}>
                                <Typography variant="h6" gutterBottom>
                                    操作概要
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    {getActionDescription(actionType, count)}
                                </Typography>
                                <Divider sx={{ my: 2 }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography variant="h4" color="primary">
                                                {count}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                総実行回数
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography variant="h4" color="warning.main">
                                                {getSeverityFromType(actionType)}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                重要度
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography variant="h4" color="info.main">
                                                {Math.ceil(count / 6)}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                月平均
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>

                            {/* 推奨アクション */}
                            <Paper sx={{ p: 2, backgroundColor: '#fff3e0' }}>
                                <Typography variant="h6" gutterBottom color="warning.main">
                                    <SecurityIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                    推奨アクション
                                </Typography>
                                <Typography variant="body2">
                                    {count > 10 ? '高頻度の操作が検出されています。ユーザーへの直接連絡を検討してください。' : 
                                     count > 5 ? '定期的な監視を継続し、パターンを観察してください。' : 
                                     '正常範囲内です。継続的な監視を行ってください。'}
                                </Typography>
                            </Paper>
                        </Box>
                    </Fade>
                )}

                {/* 統計タブ */}
                {dialogTab === 1 && (
                    <Fade in={dialogTab === 1}>
                        <Box sx={{ width: '100%', overflow: 'auto' }}>
                            <Typography variant="h6" gutterBottom>
                                月別統計データ
                            </Typography>
                            <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ minWidth: 100 }}>月</TableCell>
                                            <TableCell align="right" sx={{ minWidth: 100 }}>実行回数</TableCell>
                                            <TableCell align="right" sx={{ minWidth: 200 }}>進捗</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {statisticsData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.month}</TableCell>
                                                <TableCell align="right">{row.count}</TableCell>
                                                <TableCell align="right">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 150 }}>
                                                        <LinearProgress 
                                                            variant="determinate" 
                                                            value={(row.count / Math.max(...statisticsData.map(d => d.count))) * 100}
                                                            sx={{ flex: 1, height: 8, borderRadius: 4, minWidth: 100 }}
                                                        />
                                                        <Typography variant="caption" sx={{ minWidth: 35 }}>
                                                            {Math.round((row.count / Math.max(...statisticsData.map(d => d.count))) * 100)}%
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Fade>
                )}

                {/* 履歴タブ */}
                {dialogTab === 2 && (
                    <Fade in={dialogTab === 2}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                操作履歴（最新10件）
                            </Typography>
                            <List>
                                {historyData.map((item, index) => (
                                    <React.Fragment key={item.id}>
                                        <ListItem 
                                            sx={{ 
                                                flexDirection: 'column', 
                                                alignItems: 'stretch',
                                                backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'transparent',
                                                borderRadius: 1,
                                                mb: 1
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Chip 
                                                        size="small" 
                                                        label={item.severity} 
                                                        color={
                                                            item.severity === 'critical' ? 'error' :
                                                            item.severity === 'high' ? 'warning' :
                                                            item.severity === 'medium' ? 'info' : 'default'
                                                        }
                                                    />
                                                    <Typography variant="body2" fontWeight="bold">
                                                        {item.action}
                                                    </Typography>
                                                </Box>
                                                <IconButton 
                                                    size="small"
                                                    onClick={() => handleExpandDetails(`history-${item.id}`)}
                                                >
                                                    {expandedDetails[`history-${item.id}`] ? <ExpandLessIcon /> : <ExpandMoreIcon2 />}
                                                </IconButton>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                                <Typography variant="caption" color="text.secondary">
                                                    {item.date}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    理由: {item.reason}
                                                </Typography>
                                            </Box>
                                            <Collapse in={expandedDetails[`history-${item.id}`]}>
                                                <Box sx={{ mt: 1, p: 1, backgroundColor: 'rgba(0,0,0,0.05)', borderRadius: 1 }}>
                                                    <Typography variant="body2">
                                                        {item.details}
                                                    </Typography>
                                                </Box>
                                            </Collapse>
                                        </ListItem>
                                    </React.Fragment>
                                ))}
                            </List>
                        </Box>
                    </Fade>
                )}

                {/* 詳細分析タブ */}
                {dialogTab === 3 && (
                    <Fade in={dialogTab === 3}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                詳細分析とリスク評価
                            </Typography>
                            <Stack spacing={2}>
                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        リスクスコア
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Typography variant="h4" color={count > 10 ? 'error.main' : count > 5 ? 'warning.main' : 'success.main'}>
                                            {Math.min(100, count * 8)}
                                        </Typography>
                                        <Box sx={{ flex: 1 }}>
                                            <LinearProgress 
                                                variant="determinate" 
                                                value={Math.min(100, count * 8)}
                                                color={count > 10 ? 'error' : count > 5 ? 'warning' : 'success'}
                                                sx={{ height: 12, borderRadius: 6 }}
                                            />
                                        </Box>
                                    </Box>
                                </Paper>

                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        パターン分析
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • 最近30日間の活動: {Math.floor(count * 0.3)}回
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • 平均間隔: {count > 0 ? Math.floor(90 / count) : 0}日
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • 傾向: {count > 5 ? '増加傾向' : '安定'}
                                    </Typography>
                                </Paper>

                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        関連する他の指標
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • 通報回数: {reportCountInfo.reduce((sum, r) => sum + r.count, 0)}件
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • アカウント停止: {statusChangeAdminCount}回
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        • 総合リスクレベル: {
                                            count > 10 ? '高' : count > 5 ? '中' : '低'
                                        }
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Box>
                    </Fade>
                )}
            </Box>
        );
    };

    // 停止措置専用のダイアログコンテンツ
    const generateSuspensionDialogContent = (count) => {
        const suspensionTypes = [
            { name: '利用規約違反', count: statusChangeAdminCount1, color: 'error' },
            { name: '児童ポルノコンテンツの投稿', count: statusChangeAdminCount2, color: 'error' },
            { name: '児童ポルノコンテンツの生成', count: statusChangeAdminCount3, color: 'error' },
            { name: '著作権侵害', count: statusChangeAdminCount4, color: 'warning' },
            { name: '不審な操作', count: statusChangeAdminCount5, color: 'warning' }
        ];

        return (
            <Box sx={{ width: '100%', minHeight: '400px', overflow: 'hidden' }}>
                <Tabs 
                    value={dialogTab} 
                    onChange={handleTabChange} 
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ 
                        borderBottom: 1, 
                        borderColor: 'divider', 
                        mb: 2,
                        '& .MuiTab-root': {
                            minWidth: { xs: 'auto', sm: 160 }
                        }
                    }}
                >
                    <Tab label="概要" icon={<SecurityIcon />} />
                    <Tab label="詳細分析" icon={<AssessmentIcon />} />
                    <Tab label="停止履歴" icon={<HistoryIcon />} />
                    <Tab label="リスク評価" icon={<WarningIcon />} />
                </Tabs>

                {/* 概要タブ */}
                {dialogTab === 0 && (
                    <Fade in={dialogTab === 0}>
                        <Box>
                            <MuiAlert severity="error" sx={{ mb: 2 }}>
                                このアカウントには合計 {count} 回の停止措置が適用されています。
                            </MuiAlert>

                            <Grid container spacing={2}>
                                {suspensionTypes.map((type, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Paper sx={{ 
                                            p: 2, 
                                            borderLeft: `4px solid ${type.color === 'error' ? '#f44336' : '#ff9800'}`,
                                            backgroundColor: type.count > 0 ? '#ffebee' : '#f5f5f5'
                                        }}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {type.name}
                                            </Typography>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h4" color={type.color === 'error' ? 'error.main' : 'warning.main'}>
                                                    {type.count}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    回
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Fade>
                )}

                {/* 詳細分析タブ */}
                {dialogTab === 1 && (
                    <Fade in={dialogTab === 1}>
                        <Box sx={{ width: '100%', overflow: 'auto' }}>
                            <Typography variant="h6" gutterBottom>
                                停止措置詳細分析
                            </Typography>
                            <TableContainer component={Paper} sx={{ mb: 2, maxHeight: 400, overflow: 'auto' }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ minWidth: 200 }}>違反種別</TableCell>
                                            <TableCell align="right" sx={{ minWidth: 80 }}>回数</TableCell>
                                            <TableCell align="right" sx={{ minWidth: 80 }}>比率</TableCell>
                                            <TableCell align="center" sx={{ minWidth: 100 }}>重要度</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {suspensionTypes.map((type, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{type.name}</TableCell>
                                                <TableCell align="right">{type.count}</TableCell>
                                                <TableCell align="right">
                                                    {count > 0 ? Math.round((type.count / count) * 100) : 0}%
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Chip 
                                                        size="small" 
                                                        label={type.color === 'error' ? '高' : '中'} 
                                                        color={type.color}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Fade>
                )}

                {/* 停止履歴タブ */}
                {dialogTab === 2 && (
                    <Fade in={dialogTab === 2}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                停止措置履歴
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                ※ 実際の履歴データは管理システムから取得されます
                            </Typography>
                            <List>
                                {Array.from({ length: Math.min(count, 5) }, (_, i) => {
                                    const date = new Date();
                                    date.setDate(date.getDate() - (i * 15));
                                    const types = suspensionTypes.filter(t => t.count > 0);
                                    const randomType = types[Math.floor(Math.random() * types.length)];
                                    
                                    return (
                                        <ListItem key={i} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, mb: 1 }}>
                                            <ListItemIcon>
                                                <WarningIcon color={randomType?.color || 'warning'} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={`停止措置 #${count - i}`}
                                                secondary={
                                                    <Box>
                                                        <Typography variant="body2">
                                                            理由: {randomType?.name || '規約違反'}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            実施日: {date.toLocaleDateString('ja-JP')}
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                            <Chip 
                                                size="small" 
                                                label={randomType?.color === 'error' ? '重大' : '警告'}
                                                color={randomType?.color || 'warning'}
                                            />
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Box>
                    </Fade>
                )}

                {/* リスク評価タブ */}
                {dialogTab === 3 && (
                    <Fade in={dialogTab === 3}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                総合リスク評価
                            </Typography>
                            <Stack spacing={3}>
                                <Paper sx={{ p: 3, backgroundColor: '#ffebee' }}>
                                    <Typography variant="h6" color="error.main" gutterBottom>
                                        <WarningIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                        危険度レベル: {count >= 3 ? '高' : count >= 1 ? '中' : '低'}
                                    </Typography>
                                    <LinearProgress 
                                        variant="determinate" 
                                        value={Math.min(100, count * 25)}
                                        color="error"
                                        sx={{ height: 12, borderRadius: 6, mb: 1 }}
                                    />
                                    <Typography variant="body2" color="text.secondary">
                                        停止措置スコア: {Math.min(100, count * 25)}/100
                                    </Typography>
                                </Paper>

                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        推奨対応策
                                    </Typography>
                                    {count >= 3 ? (
                                        <MuiAlert severity="error">
                                            即座にアカウント永久停止を検討してください。
                                        </MuiAlert>
                                    ) : count >= 1 ? (
                                        <MuiAlert severity="warning">
                                            厳重な監視と再発防止策の実施が必要です。
                                        </MuiAlert>
                                    ) : (
                                        <MuiAlert severity="info">
                                            定期的な監視を継続してください。
                                        </MuiAlert>
                                    )}
                                </Paper>

                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        関連指標
                                    </Typography>
                                    <Typography variant="body2">
                                        • 通報回数: {reportCountInfo.reduce((sum, r) => sum + r.count, 0)}件
                                    </Typography>
                                    <Typography variant="body2">
                                        • AI機能制限: {aiGenerateSuspendCount}回
                                    </Typography>
                                    <Typography variant="body2">
                                        • NGワード検出: {generateImageNsfwWordCount}回
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Box>
                    </Fade>
                )}
            </Box>
        );
    };

	useEffect(() => {
        if(userIdOrDisplayId === undefined && props.userInfo !== undefined && props.userInfo.length !== 0){
            setData(props.userInfo)
            return
        }
        if(userIdOrDisplayId !== undefined){
            getUserInfo(userIdOrDisplayId).then(json => {
                setData(json)
                setLoading(false)
            })
        }
	},[props.userInfo,props.userIdOrDisplayId,props.change])

    function setData(json){
        if(json.result){
            setUserInfo(json)
            setFollowCount(json.follow)
            setFollowerCount(json.follower)
            setImageCount(json.image)
            setImageDetailCount(json.image_detail)
            setPVAllCount(json.pv)
            setPV3MonthCount(json.pv_3month)
            setPV3MonthRank(json.pv_3month_rank)

            // 管理情報
            if(loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator")){
                setImageEditAdminCount(json.image_edit_admin)
                setImageDeleteAdminCount(json.image_delete_admin)
                setImageMosaicEditAdminCount(json.image_mosaic_edit_admin)
                setAgeLimitChangeAdminCount(json.age_limit_change_admin)
                setageLimitAlertCount(json.age_limit_alert)
                setStyleOfPaintingChangeAdminCount(json.style_of_painting_change_admin)
                setMosaicAlertAdminCount(json.mosaic_alert_admin)
                setAIGenerateSuspendCount(json.ai_generate_suspend_admin)
                setGenerateImageNsfwWordCount(json.generate_image_nsfw_word)
                setStatusChangeAdminCount(json.user_status_change_admin_3)
                setStatusChangeAdminCount1(json.user_status_change_admin_3_1)
                setStatusChangeAdminCount2(json.user_status_change_admin_3_2)
                setStatusChangeAdminCount3(json.user_status_change_admin_3_3)
                setStatusChangeAdminCount4(json.user_status_change_admin_3_4)
                setStatusChangeAdminCount5(json.user_status_change_admin_3_5)
                setReportCountInfo(json.report)
            }
            // 最大1枚25ポイント
            let avg = json.pv_6month
            let p = 0
            if(avg <= 500){
                p = Math.floor(avg / 5) // 5閲覧数に対して1ポイント増加。最大50ポイント
            } else {
                p = 50
            }
            setPostGetPoint(p)
            setBasePoint(json.base_point)
            setFavoriteCount(json.favorite)
            setFavoritedCount(json.favorited)
            setPoint(json.point.point)
            setTotalPointsUsed(json.point.total_points_used)

            let targetUserId = json.user_id
            setUserId(targetUserId)
        } else {
            // プロパティでdialog関数が渡されている場合は使用し、そうでなければ内部通知を使用
            if (props.dialog) {
                props.dialog(t("common.error"), json.errors);
            } else {
                showNotification(t("common.error"), json.errors);
            }
        }
    }

    // 重要度によってアイコンと色を決定する関数
    const getSeverityConfig = (count, warningThreshold = 5, criticalThreshold = 10) => {
        if (count >= criticalThreshold) {
            return { color: 'error', icon: <WarningIcon />, severity: 'critical' };
        } else if (count >= warningThreshold) {
            return { color: 'warning', icon: <WarningIcon />, severity: 'warning' };
        } else if (count > 0) {
            return { color: 'info', icon: <InfoIcon />, severity: 'info' };
        }
        return { color: 'default', icon: null, severity: 'normal' };
    };

    return(
    <Box sx={{ maxWidth: '1400px', mx: 'auto', p: { xs: 1, sm: 2 } }}>
        {/* モダンなヘッダーセクション */}
        <Paper 
            elevation={4} 
            sx={{ 
                mb: 3, 
                background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
                color: 'white',
                borderRadius: 3,
                overflow: 'hidden'
            }}
        >
            <Box sx={{ p: { xs: 2, sm: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        mr: 2
                    }}>
                        <ReportIcon sx={{ fontSize: 30 }} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Typography 
                            variant="h4" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 'bold',
                                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
                                mb: 0.5
                            }}
                        >
                            管理者統計ダッシュボード
                        </Typography>
                        <Typography 
                            variant="subtitle1" 
                            sx={{ 
                                opacity: 0.9,
                                fontSize: { xs: '0.875rem', sm: '1rem' }
                            }}
                        >
                            ユーザー管理情報 - 詳細レポート
                        </Typography>
                    </Box>
                    {/* 通報アラートバッジ */}
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        borderRadius: 2,
                        p: 1,
                        minWidth: 80
                    }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {reportCountInfo.reduce((sum, r) => sum + r.count, 0)}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                            通報件数
                        </Typography>
                    </Box>
                </Box>
                
                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <Spinner animation="border" size="md" />
                    </Box>
                )}
                
                <MuiAlert 
                    severity="warning" 
                    sx={{ 
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: 'white',
                        border: '1px solid rgba(255,255,255,0.2)',
                        '& .MuiAlert-icon': { 
                            color: 'white' 
                        }
                    }}
                >
                    この情報は管理者および承認されたモデレーターのみに表示されます。機密性の高い情報が含まれているため、適切に取り扱ってください。
                </MuiAlert>
            </Box>
        </Paper>

        {/* メインコンテンツエリア */}
        <Grid container spacing={3}>
            {/* 管理者による対応 */}
            <Grid item xs={12} lg={6}>
                <Card elevation={2} sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography variant="h6" component="h3" sx={{ mb: 2, color: '#1976d2' }}>
                            管理者による対応
                        </Typography>
                        
                        <List dense>
                            <ListItem>
                                <ListItemText 
                                    primary="画像情報の修正" 
                                    secondary={`${imageEditAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {imageEditAdminCount > 0 && (
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={() => openDetailDialog(
                                                    '画像情報の修正',
                                                    generateEnhancedDialogContent('imageEdit', imageEditAdminCount),
                                                    'info',
                                                    { count: imageEditAdminCount, type: 'imageEdit' },
                                                    'imageEdit'
                                                )}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Chip size="small" label={imageEditAdminCount} color="default" />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                <ListItemText 
                                    primary="画像の削除" 
                                    secondary={`${imageDeleteAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {imageDeleteAdminCount > 0 && (
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={() => openDetailDialog(
                                                    '画像の削除',
                                                    generateEnhancedDialogContent('imageDelete', imageDeleteAdminCount),
                                                    'warning',
                                                    { count: imageDeleteAdminCount, type: 'imageDelete' },
                                                    'imageDelete'
                                                )}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Chip size="small" label={imageDeleteAdminCount} color="default" />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                <ListItemText 
                                    primary="モザイクの修正" 
                                    secondary={`${imageMosaicEditAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {imageMosaicEditAdminCount > 0 && (
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={() => openDetailDialog(
                                                    'モザイクの修正',
                                                    generateEnhancedDialogContent('mosaicEdit', imageMosaicEditAdminCount),
                                                    'info',
                                                    { count: imageMosaicEditAdminCount, type: 'mosaicEdit' },
                                                    'mosaicEdit'
                                                )}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Chip size="small" label={imageMosaicEditAdminCount} color="default" />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                {getSeverityConfig(ageLimitChangeAdminCount, 5, 10).icon && (
                                    <ListItemIcon>
                                        {getSeverityConfig(ageLimitChangeAdminCount, 5, 10).icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText 
                                    primary="年齢制限の修正" 
                                    secondary={`${ageLimitChangeAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip title="詳細を表示">
                                        <IconButton 
                                            size="small"
                                            onClick={() => openDetailDialog(
                                                '年齢制限の修正',
                                                generateEnhancedDialogContent('ageLimit', ageLimitChangeAdminCount),
                                                getSeverityConfig(ageLimitChangeAdminCount, 5, 10).severity,
                                                { count: ageLimitChangeAdminCount, type: 'ageLimit' },
                                                'ageLimit'
                                            )}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Chip 
                                        size="small" 
                                        label={ageLimitChangeAdminCount} 
                                        color={getSeverityConfig(ageLimitChangeAdminCount, 5, 10).color}
                                    />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                {getSeverityConfig(ageLimitAlertCount, 3, 5).icon && (
                                    <ListItemIcon>
                                        {getSeverityConfig(ageLimitAlertCount, 3, 5).icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText 
                                    primary="年齢制限の注意喚起" 
                                    secondary={`${ageLimitAlertCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip title="詳細を表示">
                                        <IconButton 
                                            size="small"
                                            onClick={() => openDetailDialog(
                                                '年齢制限の注意喚起',
                                                generateEnhancedDialogContent('ageLimitAlert', ageLimitAlertCount),
                                                getSeverityConfig(ageLimitAlertCount, 3, 5).severity,
                                                { count: ageLimitAlertCount, type: 'ageLimitAlert' },
                                                'ageLimitAlert'
                                            )}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Chip 
                                        size="small" 
                                        label={ageLimitAlertCount} 
                                        color={getSeverityConfig(ageLimitAlertCount, 3, 5).color}
                                    />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                <ListItemText 
                                    primary="画風の修正" 
                                    secondary={`${styleOfPaintingChangeAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {styleOfPaintingChangeAdminCount > 0 && (
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={() => openDetailDialog(
                                                    '画風の修正',
                                                    generateEnhancedDialogContent('styleChange', styleOfPaintingChangeAdminCount),
                                                    'info',
                                                    { count: styleOfPaintingChangeAdminCount, type: 'styleChange' },
                                                    'styleChange'
                                                )}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Chip size="small" label={styleOfPaintingChangeAdminCount} color="default" />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                <ListItemText 
                                    primary="是正通知(モザイク)" 
                                    secondary={`${mosaicAlertAdminCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {mosaicAlertAdminCount > 0 && (
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={() => openDetailDialog(
                                                    '是正通知(モザイク)',
                                                    generateEnhancedDialogContent('mosaicAlert', mosaicAlertAdminCount),
                                                    'warning',
                                                    { count: mosaicAlertAdminCount, type: 'mosaicAlert' },
                                                    'mosaicAlert'
                                                )}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Chip size="small" label={mosaicAlertAdminCount} color="default" />
                                </Box>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            </Grid>

            {/* 重要な制限措置 */}
            <Grid item xs={12} lg={6}>
                <Card elevation={2} sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography variant="h6" component="h3" sx={{ mb: 2, color: '#d32f2f' }}>
                            重要な制限措置
                        </Typography>
                        
                        <List dense>
                            <ListItem>
                                {getSeverityConfig(aiGenerateSuspendCount, 1, 2).icon && (
                                    <ListItemIcon>
                                        {getSeverityConfig(aiGenerateSuspendCount, 1, 2).icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText 
                                    primary="AI生成機能の利用制限" 
                                    secondary={`${aiGenerateSuspendCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip title="詳細を表示">
                                        <IconButton 
                                            size="small"
                                            onClick={() => openDetailDialog(
                                                'AI生成機能の利用制限',
                                                generateEnhancedDialogContent('aiSuspend', aiGenerateSuspendCount),
                                                'error',
                                                { count: aiGenerateSuspendCount, type: 'aiSuspend' },
                                                'aiSuspend'
                                            )}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Chip 
                                        size="small" 
                                        label={aiGenerateSuspendCount} 
                                        color={getSeverityConfig(aiGenerateSuspendCount, 1, 2).color}
                                    />
                                </Box>
                            </ListItem>
                            <Divider />
                            
                            <ListItem>
                                {getSeverityConfig(generateImageNsfwWordCount, 1, 3).icon && (
                                    <ListItemIcon>
                                        {getSeverityConfig(generateImageNsfwWordCount, 1, 3).icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText 
                                    primary="NGワード入力回数" 
                                    secondary={`${generateImageNsfwWordCount}回`}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip title="詳細を表示">
                                        <IconButton 
                                            size="small"
                                            onClick={() => openDetailDialog(
                                                'NGワード入力回数',
                                                generateEnhancedDialogContent('nsfwWord', generateImageNsfwWordCount),
                                                'error',
                                                { count: generateImageNsfwWordCount, type: 'nsfwWord' },
                                                'nsfwWord'
                                            )}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Chip 
                                        size="small" 
                                        label={generateImageNsfwWordCount} 
                                        color={getSeverityConfig(generateImageNsfwWordCount, 1, 3).color}
                                    />
                                </Box>
                            </ListItem>
                        </List>

                        <Accordion sx={{ mt: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    {getSeverityConfig(statusChangeAdminCount, 1, 1).icon && (
                                        <Box sx={{ mr: 1 }}>
                                            {getSeverityConfig(statusChangeAdminCount, 1, 1).icon}
                                        </Box>
                                    )}
                                    <Typography>アカウント停止措置</Typography>
                                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Tooltip title="詳細を表示">
                                            <IconButton 
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDetailDialog(
                                                        'アカウント停止措置の詳細',
                                                        generateEnhancedDialogContent('suspension', statusChangeAdminCount),
                                                        'error',
                                                        { 
                                                            count: statusChangeAdminCount, 
                                                            type: 'suspension',
                                                            details: {
                                                                violation: statusChangeAdminCount1,
                                                                childPorn: statusChangeAdminCount2,
                                                                childPornGeneration: statusChangeAdminCount3,
                                                                copyright: statusChangeAdminCount4,
                                                                suspicious: statusChangeAdminCount5
                                                            }
                                                        },
                                                        'suspension'
                                                    );
                                                }}
                                            >
                                                <HistoryIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount} 
                                            color={getSeverityConfig(statusChangeAdminCount, 1, 1).color}
                                        />
                                    </Box>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <List dense>
                                    <ListItem>
                                        <ListItemText 
                                            primary="利用規約違反" 
                                            secondary={`${statusChangeAdminCount1}回`}
                                        />
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount1} 
                                            color={statusChangeAdminCount1 > 0 ? 'error' : 'default'}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText 
                                            primary="児童ポルノコンテンツの投稿" 
                                            secondary={`${statusChangeAdminCount2}回`}
                                        />
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount2} 
                                            color={statusChangeAdminCount2 > 0 ? 'error' : 'default'}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText 
                                            primary="児童ポルノコンテンツの生成" 
                                            secondary={`${statusChangeAdminCount3}回`}
                                        />
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount3} 
                                            color={statusChangeAdminCount3 > 0 ? 'error' : 'default'}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText 
                                            primary="著作権侵害" 
                                            secondary={`${statusChangeAdminCount4}回`}
                                        />
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount4} 
                                            color={statusChangeAdminCount4 > 0 ? 'error' : 'default'}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText 
                                            primary="不審な操作" 
                                            secondary={`${statusChangeAdminCount5}回`}
                                        />
                                        <Chip 
                                            size="small" 
                                            label={statusChangeAdminCount5} 
                                            color={statusChangeAdminCount5 > 0 ? 'error' : 'default'}
                                        />
                                    </ListItem>
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    </CardContent>
                </Card>
            </Grid>

            {/* 通報情報 */}
            {reportCountInfo.length > 0 && (
                <Grid item xs={12}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h6" component="h3" sx={{ mb: 2, color: '#ff9800' }}>
                                通報された回数
                            </Typography>
                            
                            <Grid container spacing={2}>
                                {reportCountInfo.map((d, i) => (
                                    <Grid item xs={12} sm={6} lg={4} key={i}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center',
                                            p: { xs: 1, sm: 1.5 },
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 1,
                                            backgroundColor: d.count > 0 ? '#fff3e0' : 'transparent',
                                            minHeight: '48px'
                                        }}>
                                            <Typography variant="body2" sx={{ 
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                flex: 1,
                                                mr: 1
                                            }}>
                                                {d.report_name}
                                            </Typography>
                                            <Chip 
                                                size="small" 
                                                label={d.count} 
                                                color={d.count > 0 ? 'warning' : 'default'}
                                                sx={{ minWidth: '32px' }}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>

        {/* 詳細表示ダイアログ - CommonDialog使用 */}
        <CommonDialog
            open={detailDialog.open}
            onClose={closeDetailDialog}
            title={detailDialog.title}
            maxWidth="1200px"  // 管理者画面用に大きな幅を設定
            minWidth="600px"   // 最小幅も大きめに設定
            fullScreen={window.innerWidth < 1024} // タブレット以下でフルスクリーン
            mobileFullScreen={true}
            content={
                <Box sx={{ 
                    minHeight: '400px',
                    width: '100%',
                    maxWidth: '100%',
                    px: { xs: 1, sm: 2 },
                    py: 2
                }}>
                    {typeof detailDialog.content === 'string' ? (
                        <Paper sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
                            <Typography variant="body1">
                                {detailDialog.content}
                            </Typography>
                        </Paper>
                    ) : (
                        <Box sx={{ width: '100%', overflow: 'hidden' }}>
                            {detailDialog.content}
                        </Box>
                    )}
                    
                    {/* アクションボタン */}
                    <Box sx={{ 
                        mt: 3,
                        pt: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        gap: 1,
                        flexWrap: 'wrap',
                        justifyContent: { xs: 'center', sm: 'flex-start' }
                    }}>
                        <MuiButton 
                            onClick={() => {
                                // データエクスポート機能（実装例）
                                const data = {
                                    title: detailDialog.title,
                                    type: detailDialog.actionType,
                                    data: detailDialog.data,
                                    exportDate: new Date().toISOString()
                                };
                                console.log('Export data:', data);
                                showNotification('エクスポート', 'データのエクスポートが完了しました。');
                            }}
                            variant="outlined"
                            startIcon={<GetAppIcon />}
                            size="small"
                            sx={{ display: { xs: 'none', sm: 'flex' } }}
                        >
                            エクスポート
                        </MuiButton>
                        <MuiButton 
                            onClick={() => {
                                // 印刷機能
                                window.print();
                            }}
                            variant="outlined"
                            startIcon={<PrintIcon />}
                            size="small"
                            sx={{ display: { xs: 'none', sm: 'flex' } }}
                        >
                            印刷
                        </MuiButton>
                        <MuiButton 
                            onClick={() => {
                                // 共有機能（実装例）
                                if (navigator.share) {
                                    navigator.share({
                                        title: detailDialog.title,
                                        text: `管理者レポート: ${detailDialog.title}`,
                                        url: window.location.href
                                    });
                                } else {
                                    showNotification('共有', 'このブラウザでは共有機能がサポートされていません。');
                                }
                            }}
                            variant="outlined"
                            startIcon={<ShareIcon />}
                            size="small"
                            sx={{ display: { xs: 'none', sm: 'flex' } }}
                        >
                            共有
                        </MuiButton>
                    </Box>
                </Box>
            }
        />

        {/* 通知ダイアログ - シンプルな通知用 */}
        <CommonDialog
            open={notificationDialog.open}
            onClose={closeNotificationDialog}
            title={notificationDialog.title}
            content={notificationDialog.message}
            buttonLabel="OK"
            onClick={closeNotificationDialog}
            maxWidth="500px"
            minWidth="300px"
        />
    </Box>
    )
}

export default UserManageInfo;
